import { useTranslation } from 'react-i18next';
import { BackHeader } from '@/components/BackHeader';
import { DirectorForm } from '@/features/director/DirectorForm';
import { MessageCircle } from 'lucide-react';
import { asset } from '@/lib/asset';

export function DirectorPage() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-6">
      <BackHeader title={t('director.title')} />

      <div className="flex flex-col items-center gap-4 text-center">
        <div className="relative w-24 h-24 rounded-full overflow-hidden border-2 border-white/15">
          <img
            src={asset('/photos/XXXL (2).webp')}
            alt=""
            className="w-full h-full object-cover"
          />
          <span
            aria-hidden
            className="absolute inset-0 flex items-center justify-center bg-black/30"
          >
            <MessageCircle size={32} className="text-white/80" strokeWidth={1.5} />
          </span>
        </div>
        <div className="flex flex-col gap-1">
          <h2 className="font-display text-lg font-bold text-white/90">Написать управляющему</h2>
          <p className="text-sm text-white/55 max-w-[300px]">
            Вопросы, пожелания, идеи или сотрудничество. Слышим каждого и всегда рады обратной связи.
          </p>
        </div>
      </div>

      <DirectorForm />
    </div>
  );
}
